class VotacionEmpleadoService {
  constructor() {
    this.token = 'tokenjob';
  }
  resources = () => ({
    programacionplatos: {
      uri: `/v1/programacionplatos`,
      method: ['get']
    },
    programacionfechas: {
      uri: `/v1/unidadcomedor/eleccionesprogramadas`,
      method: ['get']
    },
    elegirmenu: {
      uri: `/v1/unidadcomedor/elegirmenu`,
      method: ['post']
    }
  });
}

export default VotacionEmpleadoService;
